






















































































































import settings from '@/settings'
import formations_table from '@/components/tables/formations_table'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'
import FileUpload from '@/components/file_upload'


export default {
    name: 'users_formations'
    components: { formations_table, Menus, FileUpload }

    data: ()->
        reload: true
        errors: {}
        active_names: [1]
        formation_choice_set: []
        funding_choice_set: []
        unity_options: @$store.state.unity_options
        clearable: true
        picker_options: {firstDayOfWeek:1}
        false: false
        min: 0
        precision: 0
        max_filesize: af['formation']['program']['max_filesize']/1024/1024
        authorized_formats: af['formation']['program']['authorized_formats']
        formation: {
            uid: ''
            user_in_charge_uid: ''
            formation_type: {uid: ''}
            start: ''
            end: ''
            state: {uid: ''}
            reason: ''
            program_data: ''
            program_name: ''
            program: ''
            program_dir: ''
            name: ''
            location: ''
            organization: ''
            funding: {uid: ''}
            duration: 0
            duration_unity: 1
        }

    computed:
        save_text: ()->
            text = "Ajouter"
            if @formation.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une demande de formation"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        download_file: (formation)->
            url = settings.media_url+formation.program_dir+'/'+formation.program
            filename = formation.complete_filename
            t.download_file(url, filename)
            return
        
        reset_formation: ()->
            @$refs.file_upload.clearTmpFiles()                
            @formation = {
                uid: ''
                user_in_charge_uid: ''
                formation_type: t.deep_copy(@formation_choice_set[0])
                start: ''
                end: ''
                state: {uid: ''}
                reason: ''
                program_data: ''
                program_name: ''
                program: ''
                program_dir: ''
                name: ''
                location: ''
                organization: ''
                funding: t.deep_copy(@funding_choice_set[0])
                duration: 0
                duration_unity: 1
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_formation()
            if @$refs.formation_upload?
                @$refs.formation_upload.clearFiles()
            return

        handle_tmp_file_remove: (file, fileList)->
            @$refs.formation_upload.clearFiles()
            @formation.program_data = ''
            @formation.program_name = ''
            return

        handle_file_remove: ()->
            @formation.program = ''
            @formation.program_dir = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['formation']['program']['mime_types']
            is_good_size = file.size < af['formation']['program']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.formation.program_data = e.target.result
                self.formation.program_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @formation
            return

        cancellation: (formation, text)->
            # console.log "USER FORMATION cancellation ", formation, text
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir "+text+" ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "FORMATION CANCEL", formation.uid, formation.state.slug
                    self.formation = formation
                    self.save()
                .catch (cancel)->
                    self.reload = !self.reload
            return

        edit_formation: (formation)->
            @formation = t.deep_copy(formation)
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            @errors = {}
            return

        delete_formation: (formation_uid)->
            # console.log  "DELETE FORMATION", formation_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette demande de formation ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "FORMATION DELETE", formation_uid
                    m.run('delete_object', ['formation', formation_uid])
                    .then (resp)->
                        # console.log "DELETE FORMATION", resp.body.data.formation_deletion
                        if resp.body.data.formation_deletion.ok
                            n.success()
                            self.reload = !self.reload
                        else
                            n.gql_error("users_formations: delete_formation: then", resp.body.data.formation_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_formations: delete_formation()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE FORMATION", @formation
            self = @
            m.run('save_formation', [@formation, 'users'])
            .then (resp)->
                if resp.body.data.formation_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.formation_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.formation_form_mutation.errors
                    self.errors = resp.body.data.formation_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    await self.$refs.file_upload.save_from_parent(
                      resp.body.data.formation_form_mutation.form_ret)                    
                    n.success()
                    self.reset_formation()
                    self.active_names = [1]
                    if self.$refs.formation_upload?
                        self.$refs.formation_upload.clearFiles()
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "users_formations: save()")

        get_type_choice_set: (type_name)->
            self = @
            q.run('get_type_set', [type_name+"_choice"])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_formations: get_type_choice_set: then" ,e.message)
                else
                    # console.log "USERS FORMATIONS TYPE CHOICE : ", resp.body.data[type_name+'_choice_set']
                    self[type_name+'_choice_set'] = resp.body.data[type_name+'_choice_set']
            .catch (resp)->
                n.catch_error(resp, "users_formations: get_type_choice_set()")

    beforeMount: ()->
        for name in ['formation', 'funding']
            @get_type_choice_set(name)
}
